import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import styles from './Member.scss';
import _get from 'lodash/get';
import PageContainer from './PageContainer';
import Nav from '../components/Members/Nav';
import Properties from '../components/Members/Properties';
import SavedProperties from '../components/Members/SavedProperties';
import Searches from '../components/Members/Searches';
import ClaimedProperties from '../components/Members/ClaimedProperties';
import LoginForm from '../components/Forms/LoginForm/LoginForm';
import loginStyles from '../components/Forms/FormPanel.scss';
import Loading from '../components/Loading/Loading';
import TrackedSuburbs from '../components/Members/TrackedSuburbs';
import Collections from '../components/Members/Collections';
import TrackedProperties from '../components/Members/TrackedProperties';

class Members extends Component {
  renderContent = (view) => {
    const { user } = this.props;

    if (user.authenticated) {
      return (
        <React.Fragment>
          <Route path="/members/(savedproperties)" component={SavedProperties}/>
          <Route path="/members/(favourites|properties)" component={Properties} />
          <Route path="/members/trackedsuburbs" component={TrackedSuburbs} />
          <Route path="/members/trackedproperties" component={TrackedProperties} />
          <Route path="/members/searches" component={Searches} />
          <Route path="/members/claimedproperties" component={ClaimedProperties}/>
          <Route path="/members/collection" component={Collections} />
        </React.Fragment>
      );
    } else if (!user.authenticated && view === 'collection') {
      return <Route path="/members/collection" component={Collections} />;
    }

    if (user.status === 'notloggedin') {
      return (
        <React.Fragment>
          <h3 className="mt-5 mb-1">Please log in</h3>
          <div className={'mb-5 ' + loginStyles.formBody}>
            <LoginForm />
          </div>
        </React.Fragment>
      );
    }

    return <Loading />;
  }

  render() {
    let view = _get(this.props, 'match.params.memberView');
    if (!view) this.props.history.push('/members/general');

    return (
      <PageContainer>
        <div className={`form-container pt-4 ${styles.container}`}>
          <Nav current={view} />
          {this.renderContent(view)}
        </div>
      </PageContainer>
    );
  }
}

Members.propTypes = {
  history: PropTypes.object,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {user: state.user};
}

export default connect(mapStateToProps, null)(Members);
